import { AudioDto } from 'app/models/generated'
import { logEvent } from 'app/logging/firebase'
import { logger } from 'app/logging/Logger'
import { executeMutation, fetchVersion } from 'app/api/client/graphqlClient'
import {
    createAudioDtoMutation,
    updateAudioDtoMutation,
} from 'app/graphql/customQueries'

export interface AudioRepository {
    create(): Promise<AudioDto>
    update(
        id: string,
        consultId: string,
        storageKey: string,
        url: string
    ): Promise<AudioDto>
}

export class AmplifyAudioRepository implements AudioRepository {
    async create(): Promise<AudioDto> {
        try {
            return await executeMutation<AudioDto>(
                createAudioDtoMutation,
                { input: { url: '', storageKey: '', duration: 0 } },
                'createAudioDto'
            )
        } catch (error) {
            logEvent(
                'ERROR',
                'create_audioDto_failed',
                'Create AudioDto failed',
                { error: error }
            )
            throw error
        }
    }

    async update(
        id: string,
        consultId: string,
        storageKey: string,
        url: string
    ): Promise<AudioDto> {
        try {
            const _version = await fetchVersion('AudioDto', id)

            logger.debug('[AudioRepository] AudioDto version fetched', {
                action: 'audio_dto_version_fetch',
                metadata: { id, _version },
            })

            return await executeMutation<AudioDto>(
                updateAudioDtoMutation,
                {
                    input: {
                        id,
                        url,
                        storageKey,
                        consultId,
                        _version,
                    },
                },
                'updateAudioDto'
            )
        } catch (error) {
            logEvent(
                'ERROR',
                'update_audioDto_failed',
                'Update AudioDto with storageKey failed',
                { error: error }
            )
            throw error
        }
    }
}
